import * as Mutations from '../../mutations';

export default {
  [Mutations.SET_NOTIFICATION](store, notification) {
    store.notification = notification;
  },
  [Mutations.SET_ERROR_NOTIFICATION](store, errorNotification) {
    store.errorNotification = errorNotification;
  },
};
